import { render } from "./GeneralInfo.vue?vue&type=template&id=716beeb1&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./GeneralInfo.vue?vue&type=script&lang=js"
export * from "./GeneralInfo.vue?vue&type=script&lang=js"

import "./GeneralInfo.vue?vue&type=style&index=0&id=716beeb1&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-716beeb1"

export default script